/**
 * MyComelit portal user API
 * API to interact with user from MyComelit portal
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export interface GetMyProfileResponseDto {
  loginEmail?: string;
  isoCountryCode?: GetMyProfileResponseDto.IsoCountryCodeEnum;
  isoLanguageCode?: GetMyProfileResponseDto.IsoLanguageCodeEnum;
  address?: string;
  businessName?: string;
  cellnum?: string;
  city?: string;
  company?: string;
  country?: string;
  dateOfBirth?: string;
  distributor?: string;
  ecommerceUserId?: string;
  contactEmail?: string;
  firstName?: string;
  lastName?: string;
  language?: string;
  profilePictureUrl?: string;
  region?: string;
  state?: string;
  streetNumber?: string;
  vatNumber?: string;
  zipCode?: string;
  phoneNumber?: string;
  userType?: GetMyProfileResponseDto.UserTypeEnum;
  crmUserId?: string;
  receiveNewsletter?: boolean;
  preferredContactMethod?: GetMyProfileResponseDto.PreferredContactMethodEnum;
  navigationLanguage?: string;
  betaUser?: boolean;
  userShortId?: number;
}
export namespace GetMyProfileResponseDto {
  export type IsoCountryCodeEnum =
    | 'AF'
    | 'AX'
    | 'AL'
    | 'DZ'
    | 'AS'
    | 'AD'
    | 'AO'
    | 'AI'
    | 'AQ'
    | 'AG'
    | 'AR'
    | 'AM'
    | 'AW'
    | 'AU'
    | 'AT'
    | 'AZ'
    | 'BS'
    | 'BH'
    | 'BD'
    | 'BB'
    | 'BY'
    | 'BE'
    | 'BZ'
    | 'BJ'
    | 'BM'
    | 'BT'
    | 'BO'
    | 'BQ'
    | 'BA'
    | 'BW'
    | 'BV'
    | 'BR'
    | 'IO'
    | 'BN'
    | 'BG'
    | 'BF'
    | 'BI'
    | 'KH'
    | 'CM'
    | 'CA'
    | 'CV'
    | 'KY'
    | 'CF'
    | 'TD'
    | 'CL'
    | 'CN'
    | 'CX'
    | 'CC'
    | 'CO'
    | 'KM'
    | 'CG'
    | 'CD'
    | 'CK'
    | 'CR'
    | 'CI'
    | 'HR'
    | 'CU'
    | 'CW'
    | 'CY'
    | 'CZ'
    | 'DK'
    | 'DJ'
    | 'DM'
    | 'DO'
    | 'EC'
    | 'EG'
    | 'SV'
    | 'GQ'
    | 'ER'
    | 'EE'
    | 'ET'
    | 'FK'
    | 'FO'
    | 'FJ'
    | 'FI'
    | 'FR'
    | 'GF'
    | 'PF'
    | 'TF'
    | 'GA'
    | 'GM'
    | 'GE'
    | 'DE'
    | 'GH'
    | 'GI'
    | 'GR'
    | 'GL'
    | 'GD'
    | 'GP'
    | 'GU'
    | 'GT'
    | 'GG'
    | 'GN'
    | 'GW'
    | 'GY'
    | 'HT'
    | 'HM'
    | 'VA'
    | 'HN'
    | 'HK'
    | 'HU'
    | 'IS'
    | 'IN'
    | 'ID'
    | 'IR'
    | 'IQ'
    | 'IE'
    | 'IM'
    | 'IL'
    | 'IT'
    | 'JM'
    | 'JP'
    | 'JE'
    | 'JO'
    | 'KZ'
    | 'KE'
    | 'KI'
    | 'KP'
    | 'KR'
    | 'KW'
    | 'KG'
    | 'LA'
    | 'LV'
    | 'LB'
    | 'LS'
    | 'LR'
    | 'LY'
    | 'LI'
    | 'LT'
    | 'LU'
    | 'MO'
    | 'MK'
    | 'MG'
    | 'MW'
    | 'MY'
    | 'MV'
    | 'ML'
    | 'MT'
    | 'MH'
    | 'MQ'
    | 'MR'
    | 'MU'
    | 'YT'
    | 'MX'
    | 'FM'
    | 'MD'
    | 'MC'
    | 'MN'
    | 'ME'
    | 'MS'
    | 'MA'
    | 'MZ'
    | 'MM'
    | 'NA'
    | 'NR'
    | 'NP'
    | 'NL'
    | 'NC'
    | 'NZ'
    | 'NI'
    | 'NE'
    | 'NG'
    | 'NU'
    | 'NF'
    | 'MP'
    | 'NO'
    | 'OM'
    | 'PK'
    | 'PW'
    | 'PS'
    | 'PA'
    | 'PG'
    | 'PY'
    | 'PE'
    | 'PH'
    | 'PN'
    | 'PL'
    | 'PT'
    | 'PR'
    | 'QA'
    | 'RE'
    | 'RO'
    | 'RU'
    | 'RW'
    | 'BL'
    | 'SH'
    | 'KN'
    | 'LC'
    | 'MF'
    | 'PM'
    | 'VC'
    | 'WS'
    | 'SM'
    | 'ST'
    | 'SA'
    | 'SN'
    | 'RS'
    | 'SC'
    | 'SL'
    | 'SG'
    | 'SX'
    | 'SK'
    | 'SI'
    | 'SB'
    | 'SO'
    | 'ZA'
    | 'GS'
    | 'SS'
    | 'ES'
    | 'LK'
    | 'SD'
    | 'SR'
    | 'SJ'
    | 'SZ'
    | 'SE'
    | 'CH'
    | 'SY'
    | 'TW'
    | 'TJ'
    | 'TZ'
    | 'TH'
    | 'TL'
    | 'TG'
    | 'TK'
    | 'TO'
    | 'TT'
    | 'TN'
    | 'TR'
    | 'TM'
    | 'TC'
    | 'TV'
    | 'UG'
    | 'UA'
    | 'AE'
    | 'GB'
    | 'US'
    | 'UM'
    | 'UY'
    | 'UZ'
    | 'VU'
    | 'VE'
    | 'VN'
    | 'VG'
    | 'VI'
    | 'WF'
    | 'EH'
    | 'YE'
    | 'ZM'
    | 'ZW';
  export const IsoCountryCodeEnum = {
    Af: 'AF' as IsoCountryCodeEnum,
    Ax: 'AX' as IsoCountryCodeEnum,
    Al: 'AL' as IsoCountryCodeEnum,
    Dz: 'DZ' as IsoCountryCodeEnum,
    As: 'AS' as IsoCountryCodeEnum,
    Ad: 'AD' as IsoCountryCodeEnum,
    Ao: 'AO' as IsoCountryCodeEnum,
    Ai: 'AI' as IsoCountryCodeEnum,
    Aq: 'AQ' as IsoCountryCodeEnum,
    Ag: 'AG' as IsoCountryCodeEnum,
    Ar: 'AR' as IsoCountryCodeEnum,
    Am: 'AM' as IsoCountryCodeEnum,
    Aw: 'AW' as IsoCountryCodeEnum,
    Au: 'AU' as IsoCountryCodeEnum,
    At: 'AT' as IsoCountryCodeEnum,
    Az: 'AZ' as IsoCountryCodeEnum,
    Bs: 'BS' as IsoCountryCodeEnum,
    Bh: 'BH' as IsoCountryCodeEnum,
    Bd: 'BD' as IsoCountryCodeEnum,
    Bb: 'BB' as IsoCountryCodeEnum,
    By: 'BY' as IsoCountryCodeEnum,
    Be: 'BE' as IsoCountryCodeEnum,
    Bz: 'BZ' as IsoCountryCodeEnum,
    Bj: 'BJ' as IsoCountryCodeEnum,
    Bm: 'BM' as IsoCountryCodeEnum,
    Bt: 'BT' as IsoCountryCodeEnum,
    Bo: 'BO' as IsoCountryCodeEnum,
    Bq: 'BQ' as IsoCountryCodeEnum,
    Ba: 'BA' as IsoCountryCodeEnum,
    Bw: 'BW' as IsoCountryCodeEnum,
    Bv: 'BV' as IsoCountryCodeEnum,
    Br: 'BR' as IsoCountryCodeEnum,
    Io: 'IO' as IsoCountryCodeEnum,
    Bn: 'BN' as IsoCountryCodeEnum,
    Bg: 'BG' as IsoCountryCodeEnum,
    Bf: 'BF' as IsoCountryCodeEnum,
    Bi: 'BI' as IsoCountryCodeEnum,
    Kh: 'KH' as IsoCountryCodeEnum,
    Cm: 'CM' as IsoCountryCodeEnum,
    Ca: 'CA' as IsoCountryCodeEnum,
    Cv: 'CV' as IsoCountryCodeEnum,
    Ky: 'KY' as IsoCountryCodeEnum,
    Cf: 'CF' as IsoCountryCodeEnum,
    Td: 'TD' as IsoCountryCodeEnum,
    Cl: 'CL' as IsoCountryCodeEnum,
    Cn: 'CN' as IsoCountryCodeEnum,
    Cx: 'CX' as IsoCountryCodeEnum,
    Cc: 'CC' as IsoCountryCodeEnum,
    Co: 'CO' as IsoCountryCodeEnum,
    Km: 'KM' as IsoCountryCodeEnum,
    Cg: 'CG' as IsoCountryCodeEnum,
    Cd: 'CD' as IsoCountryCodeEnum,
    Ck: 'CK' as IsoCountryCodeEnum,
    Cr: 'CR' as IsoCountryCodeEnum,
    Ci: 'CI' as IsoCountryCodeEnum,
    Hr: 'HR' as IsoCountryCodeEnum,
    Cu: 'CU' as IsoCountryCodeEnum,
    Cw: 'CW' as IsoCountryCodeEnum,
    Cy: 'CY' as IsoCountryCodeEnum,
    Cz: 'CZ' as IsoCountryCodeEnum,
    Dk: 'DK' as IsoCountryCodeEnum,
    Dj: 'DJ' as IsoCountryCodeEnum,
    Dm: 'DM' as IsoCountryCodeEnum,
    Do: 'DO' as IsoCountryCodeEnum,
    Ec: 'EC' as IsoCountryCodeEnum,
    Eg: 'EG' as IsoCountryCodeEnum,
    Sv: 'SV' as IsoCountryCodeEnum,
    Gq: 'GQ' as IsoCountryCodeEnum,
    Er: 'ER' as IsoCountryCodeEnum,
    Ee: 'EE' as IsoCountryCodeEnum,
    Et: 'ET' as IsoCountryCodeEnum,
    Fk: 'FK' as IsoCountryCodeEnum,
    Fo: 'FO' as IsoCountryCodeEnum,
    Fj: 'FJ' as IsoCountryCodeEnum,
    Fi: 'FI' as IsoCountryCodeEnum,
    Fr: 'FR' as IsoCountryCodeEnum,
    Gf: 'GF' as IsoCountryCodeEnum,
    Pf: 'PF' as IsoCountryCodeEnum,
    Tf: 'TF' as IsoCountryCodeEnum,
    Ga: 'GA' as IsoCountryCodeEnum,
    Gm: 'GM' as IsoCountryCodeEnum,
    Ge: 'GE' as IsoCountryCodeEnum,
    De: 'DE' as IsoCountryCodeEnum,
    Gh: 'GH' as IsoCountryCodeEnum,
    Gi: 'GI' as IsoCountryCodeEnum,
    Gr: 'GR' as IsoCountryCodeEnum,
    Gl: 'GL' as IsoCountryCodeEnum,
    Gd: 'GD' as IsoCountryCodeEnum,
    Gp: 'GP' as IsoCountryCodeEnum,
    Gu: 'GU' as IsoCountryCodeEnum,
    Gt: 'GT' as IsoCountryCodeEnum,
    Gg: 'GG' as IsoCountryCodeEnum,
    Gn: 'GN' as IsoCountryCodeEnum,
    Gw: 'GW' as IsoCountryCodeEnum,
    Gy: 'GY' as IsoCountryCodeEnum,
    Ht: 'HT' as IsoCountryCodeEnum,
    Hm: 'HM' as IsoCountryCodeEnum,
    Va: 'VA' as IsoCountryCodeEnum,
    Hn: 'HN' as IsoCountryCodeEnum,
    Hk: 'HK' as IsoCountryCodeEnum,
    Hu: 'HU' as IsoCountryCodeEnum,
    Is: 'IS' as IsoCountryCodeEnum,
    In: 'IN' as IsoCountryCodeEnum,
    Id: 'ID' as IsoCountryCodeEnum,
    Ir: 'IR' as IsoCountryCodeEnum,
    Iq: 'IQ' as IsoCountryCodeEnum,
    Ie: 'IE' as IsoCountryCodeEnum,
    Im: 'IM' as IsoCountryCodeEnum,
    Il: 'IL' as IsoCountryCodeEnum,
    It: 'IT' as IsoCountryCodeEnum,
    Jm: 'JM' as IsoCountryCodeEnum,
    Jp: 'JP' as IsoCountryCodeEnum,
    Je: 'JE' as IsoCountryCodeEnum,
    Jo: 'JO' as IsoCountryCodeEnum,
    Kz: 'KZ' as IsoCountryCodeEnum,
    Ke: 'KE' as IsoCountryCodeEnum,
    Ki: 'KI' as IsoCountryCodeEnum,
    Kp: 'KP' as IsoCountryCodeEnum,
    Kr: 'KR' as IsoCountryCodeEnum,
    Kw: 'KW' as IsoCountryCodeEnum,
    Kg: 'KG' as IsoCountryCodeEnum,
    La: 'LA' as IsoCountryCodeEnum,
    Lv: 'LV' as IsoCountryCodeEnum,
    Lb: 'LB' as IsoCountryCodeEnum,
    Ls: 'LS' as IsoCountryCodeEnum,
    Lr: 'LR' as IsoCountryCodeEnum,
    Ly: 'LY' as IsoCountryCodeEnum,
    Li: 'LI' as IsoCountryCodeEnum,
    Lt: 'LT' as IsoCountryCodeEnum,
    Lu: 'LU' as IsoCountryCodeEnum,
    Mo: 'MO' as IsoCountryCodeEnum,
    Mk: 'MK' as IsoCountryCodeEnum,
    Mg: 'MG' as IsoCountryCodeEnum,
    Mw: 'MW' as IsoCountryCodeEnum,
    My: 'MY' as IsoCountryCodeEnum,
    Mv: 'MV' as IsoCountryCodeEnum,
    Ml: 'ML' as IsoCountryCodeEnum,
    Mt: 'MT' as IsoCountryCodeEnum,
    Mh: 'MH' as IsoCountryCodeEnum,
    Mq: 'MQ' as IsoCountryCodeEnum,
    Mr: 'MR' as IsoCountryCodeEnum,
    Mu: 'MU' as IsoCountryCodeEnum,
    Yt: 'YT' as IsoCountryCodeEnum,
    Mx: 'MX' as IsoCountryCodeEnum,
    Fm: 'FM' as IsoCountryCodeEnum,
    Md: 'MD' as IsoCountryCodeEnum,
    Mc: 'MC' as IsoCountryCodeEnum,
    Mn: 'MN' as IsoCountryCodeEnum,
    Me: 'ME' as IsoCountryCodeEnum,
    Ms: 'MS' as IsoCountryCodeEnum,
    Ma: 'MA' as IsoCountryCodeEnum,
    Mz: 'MZ' as IsoCountryCodeEnum,
    Mm: 'MM' as IsoCountryCodeEnum,
    Na: 'NA' as IsoCountryCodeEnum,
    Nr: 'NR' as IsoCountryCodeEnum,
    Np: 'NP' as IsoCountryCodeEnum,
    Nl: 'NL' as IsoCountryCodeEnum,
    Nc: 'NC' as IsoCountryCodeEnum,
    Nz: 'NZ' as IsoCountryCodeEnum,
    Ni: 'NI' as IsoCountryCodeEnum,
    Ne: 'NE' as IsoCountryCodeEnum,
    Ng: 'NG' as IsoCountryCodeEnum,
    Nu: 'NU' as IsoCountryCodeEnum,
    Nf: 'NF' as IsoCountryCodeEnum,
    Mp: 'MP' as IsoCountryCodeEnum,
    No: 'NO' as IsoCountryCodeEnum,
    Om: 'OM' as IsoCountryCodeEnum,
    Pk: 'PK' as IsoCountryCodeEnum,
    Pw: 'PW' as IsoCountryCodeEnum,
    Ps: 'PS' as IsoCountryCodeEnum,
    Pa: 'PA' as IsoCountryCodeEnum,
    Pg: 'PG' as IsoCountryCodeEnum,
    Py: 'PY' as IsoCountryCodeEnum,
    Pe: 'PE' as IsoCountryCodeEnum,
    Ph: 'PH' as IsoCountryCodeEnum,
    Pn: 'PN' as IsoCountryCodeEnum,
    Pl: 'PL' as IsoCountryCodeEnum,
    Pt: 'PT' as IsoCountryCodeEnum,
    Pr: 'PR' as IsoCountryCodeEnum,
    Qa: 'QA' as IsoCountryCodeEnum,
    Re: 'RE' as IsoCountryCodeEnum,
    Ro: 'RO' as IsoCountryCodeEnum,
    Ru: 'RU' as IsoCountryCodeEnum,
    Rw: 'RW' as IsoCountryCodeEnum,
    Bl: 'BL' as IsoCountryCodeEnum,
    Sh: 'SH' as IsoCountryCodeEnum,
    Kn: 'KN' as IsoCountryCodeEnum,
    Lc: 'LC' as IsoCountryCodeEnum,
    Mf: 'MF' as IsoCountryCodeEnum,
    Pm: 'PM' as IsoCountryCodeEnum,
    Vc: 'VC' as IsoCountryCodeEnum,
    Ws: 'WS' as IsoCountryCodeEnum,
    Sm: 'SM' as IsoCountryCodeEnum,
    St: 'ST' as IsoCountryCodeEnum,
    Sa: 'SA' as IsoCountryCodeEnum,
    Sn: 'SN' as IsoCountryCodeEnum,
    Rs: 'RS' as IsoCountryCodeEnum,
    Sc: 'SC' as IsoCountryCodeEnum,
    Sl: 'SL' as IsoCountryCodeEnum,
    Sg: 'SG' as IsoCountryCodeEnum,
    Sx: 'SX' as IsoCountryCodeEnum,
    Sk: 'SK' as IsoCountryCodeEnum,
    Si: 'SI' as IsoCountryCodeEnum,
    Sb: 'SB' as IsoCountryCodeEnum,
    So: 'SO' as IsoCountryCodeEnum,
    Za: 'ZA' as IsoCountryCodeEnum,
    Gs: 'GS' as IsoCountryCodeEnum,
    Ss: 'SS' as IsoCountryCodeEnum,
    Es: 'ES' as IsoCountryCodeEnum,
    Lk: 'LK' as IsoCountryCodeEnum,
    Sd: 'SD' as IsoCountryCodeEnum,
    Sr: 'SR' as IsoCountryCodeEnum,
    Sj: 'SJ' as IsoCountryCodeEnum,
    Sz: 'SZ' as IsoCountryCodeEnum,
    Se: 'SE' as IsoCountryCodeEnum,
    Ch: 'CH' as IsoCountryCodeEnum,
    Sy: 'SY' as IsoCountryCodeEnum,
    Tw: 'TW' as IsoCountryCodeEnum,
    Tj: 'TJ' as IsoCountryCodeEnum,
    Tz: 'TZ' as IsoCountryCodeEnum,
    Th: 'TH' as IsoCountryCodeEnum,
    Tl: 'TL' as IsoCountryCodeEnum,
    Tg: 'TG' as IsoCountryCodeEnum,
    Tk: 'TK' as IsoCountryCodeEnum,
    To: 'TO' as IsoCountryCodeEnum,
    Tt: 'TT' as IsoCountryCodeEnum,
    Tn: 'TN' as IsoCountryCodeEnum,
    Tr: 'TR' as IsoCountryCodeEnum,
    Tm: 'TM' as IsoCountryCodeEnum,
    Tc: 'TC' as IsoCountryCodeEnum,
    Tv: 'TV' as IsoCountryCodeEnum,
    Ug: 'UG' as IsoCountryCodeEnum,
    Ua: 'UA' as IsoCountryCodeEnum,
    Ae: 'AE' as IsoCountryCodeEnum,
    Gb: 'GB' as IsoCountryCodeEnum,
    Us: 'US' as IsoCountryCodeEnum,
    Um: 'UM' as IsoCountryCodeEnum,
    Uy: 'UY' as IsoCountryCodeEnum,
    Uz: 'UZ' as IsoCountryCodeEnum,
    Vu: 'VU' as IsoCountryCodeEnum,
    Ve: 'VE' as IsoCountryCodeEnum,
    Vn: 'VN' as IsoCountryCodeEnum,
    Vg: 'VG' as IsoCountryCodeEnum,
    Vi: 'VI' as IsoCountryCodeEnum,
    Wf: 'WF' as IsoCountryCodeEnum,
    Eh: 'EH' as IsoCountryCodeEnum,
    Ye: 'YE' as IsoCountryCodeEnum,
    Zm: 'ZM' as IsoCountryCodeEnum,
    Zw: 'ZW' as IsoCountryCodeEnum
  };
  export type IsoLanguageCodeEnum =
    | 'aa'
    | 'ab'
    | 'ae'
    | 'af'
    | 'ak'
    | 'am'
    | 'an'
    | 'ar'
    | 'as'
    | 'av'
    | 'ay'
    | 'az'
    | 'ba'
    | 'be'
    | 'bg'
    | 'bh'
    | 'bi'
    | 'bm'
    | 'bn'
    | 'bo'
    | 'br'
    | 'bs'
    | 'ca'
    | 'ce'
    | 'ch'
    | 'co'
    | 'cr'
    | 'cs'
    | 'cu'
    | 'cv'
    | 'cy'
    | 'da'
    | 'de'
    | 'dv'
    | 'dz'
    | 'ee'
    | 'el'
    | 'en'
    | 'eo'
    | 'es'
    | 'et'
    | 'eu'
    | 'fa'
    | 'ff'
    | 'fi'
    | 'fj'
    | 'fo'
    | 'fr'
    | 'fy'
    | 'ga'
    | 'gd'
    | 'gl'
    | 'gn'
    | 'gu'
    | 'gv'
    | 'ha'
    | 'he'
    | 'hi'
    | 'ho'
    | 'hr'
    | 'ht'
    | 'hu'
    | 'hy'
    | 'hz'
    | 'ia'
    | 'id'
    | 'ie'
    | 'ig'
    | 'ii'
    | 'ik'
    | 'io'
    | 'is'
    | 'it'
    | 'iu'
    | 'ja'
    | 'jv'
    | 'ka'
    | 'kg'
    | 'ki'
    | 'kj'
    | 'kk'
    | 'kl'
    | 'km'
    | 'kn'
    | 'ko'
    | 'kr'
    | 'ks'
    | 'ku'
    | 'kv'
    | 'kw'
    | 'ky'
    | 'la'
    | 'lb'
    | 'lg'
    | 'li'
    | 'ln'
    | 'lo'
    | 'lt'
    | 'lu'
    | 'lv'
    | 'mg'
    | 'mh'
    | 'mi'
    | 'mk'
    | 'ml'
    | 'mn'
    | 'mr'
    | 'ms'
    | 'mt'
    | 'my'
    | 'na'
    | 'nb'
    | 'nd'
    | 'ne'
    | 'ng'
    | 'nl'
    | 'nn'
    | 'no'
    | 'nr'
    | 'nv'
    | 'ny'
    | 'oc'
    | 'oj'
    | 'om'
    | 'or'
    | 'os'
    | 'pa'
    | 'pi'
    | 'pl'
    | 'ps'
    | 'pt'
    | 'qu'
    | 'rm'
    | 'rn'
    | 'ro'
    | 'ru'
    | 'rw'
    | 'sa'
    | 'sc'
    | 'sd'
    | 'se'
    | 'sg'
    | 'si'
    | 'sk'
    | 'sl'
    | 'sm'
    | 'sn'
    | 'so'
    | 'sq'
    | 'sr'
    | 'ss'
    | 'st'
    | 'su'
    | 'sv'
    | 'sw'
    | 'ta'
    | 'te'
    | 'tg'
    | 'th'
    | 'ti'
    | 'tk'
    | 'tl'
    | 'tn'
    | 'to'
    | 'tr'
    | 'ts'
    | 'tt'
    | 'tw'
    | 'ty'
    | 'ug'
    | 'uk'
    | 'ur'
    | 'uz'
    | 've'
    | 'vi'
    | 'vo'
    | 'wa'
    | 'wo'
    | 'xh'
    | 'yi'
    | 'yo'
    | 'za'
    | 'zh'
    | 'zu';
  export const IsoLanguageCodeEnum = {
    Aa: 'aa' as IsoLanguageCodeEnum,
    Ab: 'ab' as IsoLanguageCodeEnum,
    Ae: 'ae' as IsoLanguageCodeEnum,
    Af: 'af' as IsoLanguageCodeEnum,
    Ak: 'ak' as IsoLanguageCodeEnum,
    Am: 'am' as IsoLanguageCodeEnum,
    An: 'an' as IsoLanguageCodeEnum,
    Ar: 'ar' as IsoLanguageCodeEnum,
    As: 'as' as IsoLanguageCodeEnum,
    Av: 'av' as IsoLanguageCodeEnum,
    Ay: 'ay' as IsoLanguageCodeEnum,
    Az: 'az' as IsoLanguageCodeEnum,
    Ba: 'ba' as IsoLanguageCodeEnum,
    Be: 'be' as IsoLanguageCodeEnum,
    Bg: 'bg' as IsoLanguageCodeEnum,
    Bh: 'bh' as IsoLanguageCodeEnum,
    Bi: 'bi' as IsoLanguageCodeEnum,
    Bm: 'bm' as IsoLanguageCodeEnum,
    Bn: 'bn' as IsoLanguageCodeEnum,
    Bo: 'bo' as IsoLanguageCodeEnum,
    Br: 'br' as IsoLanguageCodeEnum,
    Bs: 'bs' as IsoLanguageCodeEnum,
    Ca: 'ca' as IsoLanguageCodeEnum,
    Ce: 'ce' as IsoLanguageCodeEnum,
    Ch: 'ch' as IsoLanguageCodeEnum,
    Co: 'co' as IsoLanguageCodeEnum,
    Cr: 'cr' as IsoLanguageCodeEnum,
    Cs: 'cs' as IsoLanguageCodeEnum,
    Cu: 'cu' as IsoLanguageCodeEnum,
    Cv: 'cv' as IsoLanguageCodeEnum,
    Cy: 'cy' as IsoLanguageCodeEnum,
    Da: 'da' as IsoLanguageCodeEnum,
    De: 'de' as IsoLanguageCodeEnum,
    Dv: 'dv' as IsoLanguageCodeEnum,
    Dz: 'dz' as IsoLanguageCodeEnum,
    Ee: 'ee' as IsoLanguageCodeEnum,
    El: 'el' as IsoLanguageCodeEnum,
    En: 'en' as IsoLanguageCodeEnum,
    Eo: 'eo' as IsoLanguageCodeEnum,
    Es: 'es' as IsoLanguageCodeEnum,
    Et: 'et' as IsoLanguageCodeEnum,
    Eu: 'eu' as IsoLanguageCodeEnum,
    Fa: 'fa' as IsoLanguageCodeEnum,
    Ff: 'ff' as IsoLanguageCodeEnum,
    Fi: 'fi' as IsoLanguageCodeEnum,
    Fj: 'fj' as IsoLanguageCodeEnum,
    Fo: 'fo' as IsoLanguageCodeEnum,
    Fr: 'fr' as IsoLanguageCodeEnum,
    Fy: 'fy' as IsoLanguageCodeEnum,
    Ga: 'ga' as IsoLanguageCodeEnum,
    Gd: 'gd' as IsoLanguageCodeEnum,
    Gl: 'gl' as IsoLanguageCodeEnum,
    Gn: 'gn' as IsoLanguageCodeEnum,
    Gu: 'gu' as IsoLanguageCodeEnum,
    Gv: 'gv' as IsoLanguageCodeEnum,
    Ha: 'ha' as IsoLanguageCodeEnum,
    He: 'he' as IsoLanguageCodeEnum,
    Hi: 'hi' as IsoLanguageCodeEnum,
    Ho: 'ho' as IsoLanguageCodeEnum,
    Hr: 'hr' as IsoLanguageCodeEnum,
    Ht: 'ht' as IsoLanguageCodeEnum,
    Hu: 'hu' as IsoLanguageCodeEnum,
    Hy: 'hy' as IsoLanguageCodeEnum,
    Hz: 'hz' as IsoLanguageCodeEnum,
    Ia: 'ia' as IsoLanguageCodeEnum,
    Id: 'id' as IsoLanguageCodeEnum,
    Ie: 'ie' as IsoLanguageCodeEnum,
    Ig: 'ig' as IsoLanguageCodeEnum,
    Ii: 'ii' as IsoLanguageCodeEnum,
    Ik: 'ik' as IsoLanguageCodeEnum,
    Io: 'io' as IsoLanguageCodeEnum,
    Is: 'is' as IsoLanguageCodeEnum,
    It: 'it' as IsoLanguageCodeEnum,
    Iu: 'iu' as IsoLanguageCodeEnum,
    Ja: 'ja' as IsoLanguageCodeEnum,
    Jv: 'jv' as IsoLanguageCodeEnum,
    Ka: 'ka' as IsoLanguageCodeEnum,
    Kg: 'kg' as IsoLanguageCodeEnum,
    Ki: 'ki' as IsoLanguageCodeEnum,
    Kj: 'kj' as IsoLanguageCodeEnum,
    Kk: 'kk' as IsoLanguageCodeEnum,
    Kl: 'kl' as IsoLanguageCodeEnum,
    Km: 'km' as IsoLanguageCodeEnum,
    Kn: 'kn' as IsoLanguageCodeEnum,
    Ko: 'ko' as IsoLanguageCodeEnum,
    Kr: 'kr' as IsoLanguageCodeEnum,
    Ks: 'ks' as IsoLanguageCodeEnum,
    Ku: 'ku' as IsoLanguageCodeEnum,
    Kv: 'kv' as IsoLanguageCodeEnum,
    Kw: 'kw' as IsoLanguageCodeEnum,
    Ky: 'ky' as IsoLanguageCodeEnum,
    La: 'la' as IsoLanguageCodeEnum,
    Lb: 'lb' as IsoLanguageCodeEnum,
    Lg: 'lg' as IsoLanguageCodeEnum,
    Li: 'li' as IsoLanguageCodeEnum,
    Ln: 'ln' as IsoLanguageCodeEnum,
    Lo: 'lo' as IsoLanguageCodeEnum,
    Lt: 'lt' as IsoLanguageCodeEnum,
    Lu: 'lu' as IsoLanguageCodeEnum,
    Lv: 'lv' as IsoLanguageCodeEnum,
    Mg: 'mg' as IsoLanguageCodeEnum,
    Mh: 'mh' as IsoLanguageCodeEnum,
    Mi: 'mi' as IsoLanguageCodeEnum,
    Mk: 'mk' as IsoLanguageCodeEnum,
    Ml: 'ml' as IsoLanguageCodeEnum,
    Mn: 'mn' as IsoLanguageCodeEnum,
    Mr: 'mr' as IsoLanguageCodeEnum,
    Ms: 'ms' as IsoLanguageCodeEnum,
    Mt: 'mt' as IsoLanguageCodeEnum,
    My: 'my' as IsoLanguageCodeEnum,
    Na: 'na' as IsoLanguageCodeEnum,
    Nb: 'nb' as IsoLanguageCodeEnum,
    Nd: 'nd' as IsoLanguageCodeEnum,
    Ne: 'ne' as IsoLanguageCodeEnum,
    Ng: 'ng' as IsoLanguageCodeEnum,
    Nl: 'nl' as IsoLanguageCodeEnum,
    Nn: 'nn' as IsoLanguageCodeEnum,
    No: 'no' as IsoLanguageCodeEnum,
    Nr: 'nr' as IsoLanguageCodeEnum,
    Nv: 'nv' as IsoLanguageCodeEnum,
    Ny: 'ny' as IsoLanguageCodeEnum,
    Oc: 'oc' as IsoLanguageCodeEnum,
    Oj: 'oj' as IsoLanguageCodeEnum,
    Om: 'om' as IsoLanguageCodeEnum,
    Or: 'or' as IsoLanguageCodeEnum,
    Os: 'os' as IsoLanguageCodeEnum,
    Pa: 'pa' as IsoLanguageCodeEnum,
    Pi: 'pi' as IsoLanguageCodeEnum,
    Pl: 'pl' as IsoLanguageCodeEnum,
    Ps: 'ps' as IsoLanguageCodeEnum,
    Pt: 'pt' as IsoLanguageCodeEnum,
    Qu: 'qu' as IsoLanguageCodeEnum,
    Rm: 'rm' as IsoLanguageCodeEnum,
    Rn: 'rn' as IsoLanguageCodeEnum,
    Ro: 'ro' as IsoLanguageCodeEnum,
    Ru: 'ru' as IsoLanguageCodeEnum,
    Rw: 'rw' as IsoLanguageCodeEnum,
    Sa: 'sa' as IsoLanguageCodeEnum,
    Sc: 'sc' as IsoLanguageCodeEnum,
    Sd: 'sd' as IsoLanguageCodeEnum,
    Se: 'se' as IsoLanguageCodeEnum,
    Sg: 'sg' as IsoLanguageCodeEnum,
    Si: 'si' as IsoLanguageCodeEnum,
    Sk: 'sk' as IsoLanguageCodeEnum,
    Sl: 'sl' as IsoLanguageCodeEnum,
    Sm: 'sm' as IsoLanguageCodeEnum,
    Sn: 'sn' as IsoLanguageCodeEnum,
    So: 'so' as IsoLanguageCodeEnum,
    Sq: 'sq' as IsoLanguageCodeEnum,
    Sr: 'sr' as IsoLanguageCodeEnum,
    Ss: 'ss' as IsoLanguageCodeEnum,
    St: 'st' as IsoLanguageCodeEnum,
    Su: 'su' as IsoLanguageCodeEnum,
    Sv: 'sv' as IsoLanguageCodeEnum,
    Sw: 'sw' as IsoLanguageCodeEnum,
    Ta: 'ta' as IsoLanguageCodeEnum,
    Te: 'te' as IsoLanguageCodeEnum,
    Tg: 'tg' as IsoLanguageCodeEnum,
    Th: 'th' as IsoLanguageCodeEnum,
    Ti: 'ti' as IsoLanguageCodeEnum,
    Tk: 'tk' as IsoLanguageCodeEnum,
    Tl: 'tl' as IsoLanguageCodeEnum,
    Tn: 'tn' as IsoLanguageCodeEnum,
    To: 'to' as IsoLanguageCodeEnum,
    Tr: 'tr' as IsoLanguageCodeEnum,
    Ts: 'ts' as IsoLanguageCodeEnum,
    Tt: 'tt' as IsoLanguageCodeEnum,
    Tw: 'tw' as IsoLanguageCodeEnum,
    Ty: 'ty' as IsoLanguageCodeEnum,
    Ug: 'ug' as IsoLanguageCodeEnum,
    Uk: 'uk' as IsoLanguageCodeEnum,
    Ur: 'ur' as IsoLanguageCodeEnum,
    Uz: 'uz' as IsoLanguageCodeEnum,
    Ve: 've' as IsoLanguageCodeEnum,
    Vi: 'vi' as IsoLanguageCodeEnum,
    Vo: 'vo' as IsoLanguageCodeEnum,
    Wa: 'wa' as IsoLanguageCodeEnum,
    Wo: 'wo' as IsoLanguageCodeEnum,
    Xh: 'xh' as IsoLanguageCodeEnum,
    Yi: 'yi' as IsoLanguageCodeEnum,
    Yo: 'yo' as IsoLanguageCodeEnum,
    Za: 'za' as IsoLanguageCodeEnum,
    Zh: 'zh' as IsoLanguageCodeEnum,
    Zu: 'zu' as IsoLanguageCodeEnum
  };
  export type UserTypeEnum =
    | 'INSTALLER'
    | 'DISTRIBUTOR'
    | 'DESIGNER'
    | 'BUILDING_MANAGER'
    | 'EXCELLENCE_PARTNER'
    | 'END_USER'
    | 'ARCHITECT'
    | 'SYSTEM_INTEGRATOR';
  export const UserTypeEnum = {
    Installer: 'INSTALLER' as UserTypeEnum,
    Distributor: 'DISTRIBUTOR' as UserTypeEnum,
    Designer: 'DESIGNER' as UserTypeEnum,
    BuildingManager: 'BUILDING_MANAGER' as UserTypeEnum,
    ExcellencePartner: 'EXCELLENCE_PARTNER' as UserTypeEnum,
    EndUser: 'END_USER' as UserTypeEnum,
    Architect: 'ARCHITECT' as UserTypeEnum,
    SystemIntegrator: 'SYSTEM_INTEGRATOR' as UserTypeEnum
  };
  export type PreferredContactMethodEnum = 'EMAIL';
  export const PreferredContactMethodEnum = {
    Email: 'EMAIL' as PreferredContactMethodEnum
  };
}
